import { AxiosError } from 'axios';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';

import { TableContext } from '../../../components/Table/TableContext';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';
import useBaVerificationStatsCard from './useBaVerificationStatsCard';

const useBaConfirmDriverProfile = () => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const tableContext = useContext(TableContext);
  const { getBaVerificationStats } = useBaVerificationStatsCard();

  const onBaConfirmDriverProfileError = (
    err: AxiosError<ErrorHttpResponse>,
  ) => {
    toast.error(
      err?.response?.data?.message ??
      'Something went wrong while confirming driver profile.',
    );
    // setShowSuccessModal(true);
  };

  const onBaConfirmDriverProfileSuccess = ({
    data,
    message,
  }: SuccessHttpResponse<any>) => {
    tableContext?.setRefreshTable(!tableContext?.refreshTable);
    getBaVerificationStats();
  };

  const confirmDriverProfile = async (driverId: any) => {
    const url: HttpConfig = {
      url: `ba/v1/drivers/verification/${driverId}/approve-driver`,
      method: 'post',
      // data: { status }
    };

    await request(
      url,
      onBaConfirmDriverProfileSuccess,
      setLoading,
      onBaConfirmDriverProfileError,
    );
  };

  return {
    confirmDriverProfile,
    loading,
  };
};

export default useBaConfirmDriverProfile;
